module.exports = __webpack_public_path__ + "img/logo_nav.414cdef1.svg";